export default __webpack_public_path__ + "static/media/promoPlus.3b3819c4.svg";